// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MadeWithPrezly_wrapper__Trp41","logo":"MadeWithPrezly_logo__WHJfU","text":"MadeWithPrezly_text__yUhq2"};